import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import {rolesDar} from '../../common/services/roles/roles-dar';
import {CommentsService} from '../../common/services/comments/comments.service';
import {CommentsModel} from '../../common/services/comments/comments.model';
import {Dossiers} from '../../common/services';
import {Individu, PubSubService} from '@Common/core/services';
import {CommentTypeEnum} from '../../common/services/enums/commentTypeEnum';
import {SubSink} from "@Common/core/utils/subsink";
import {finalize} from "rxjs/operators";
import {ReminderService} from "app/dar/common/services/reminder/reminder.service";


@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CommentsComponent implements OnInit, OnDestroy {
  @Output() changer = new EventEmitter();
  @Input() dossier: Dossiers;
  @Input() commentator: Individu;
  @Input() roles: rolesDar[];
  @Input() opened: boolean;
  comments: CommentsModel[];
  subSink = new SubSink();
  commentType: number;
  loader = false;
  comment = <CommentsModel>{
    id: 0,
  };
  currentCommentFilter: number = null;

  constructor(
    private commentsSvc: CommentsService,
    private pubSubSvc: PubSubService,
    private reminderSvc: ReminderService) { }

  ngOnInit(): void {
    if (this.isGestionnaire()) {
      this.clickAll();
    } else {
      this.clickPublic();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.opened?.currentValue) {
      this.reminderSvc.delReminder(this.dossier.id);
    }
  }

  close(ctsedit): void {
    ctsedit.close();
    this.changer.emit();
  }

  openEditComment(comment: CommentsModel, ctsedit): void {
    this.comment = comment;
    ctsedit.toggle();
  }

  editClose(comment: CommentsModel, ctsedit): void {
    this._reloadComments();
    ctsedit.close();
  }

  deleteComment(comment: CommentsModel): void {
    this.comments = this.comments.filter(obj => obj !== comment);
  }

  private _reloadComments(): void {
    this.comments = [];
    this.pubSubSvc.publish('loading', true);
    this.subSink.sink = this.commentsSvc.getMessages(this.currentCommentFilter, this.dossier.id)
      .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
      .subscribe(_data => { this.comments = _data.list;});
  }

  isGestionnaire() {
    return (this.roles.length >= 1);
  }

  ngOnDestroy(): void {}

  clickAll() {
    this.currentCommentFilter = null;
    this._reloadComments();
  }

  clickPublic() {
    this.currentCommentFilter = CommentTypeEnum.public;
    this._reloadComments();
  }

  clickPrivate() {
    this.currentCommentFilter = CommentTypeEnum.private;
    this._reloadComments();
  }
}
